module.exports = __webpack_public_path__ + "static/img/empty.ded70b18.png";